<template>
  <div class="col-xs-12 attributesBlock productBgBlock">
    <div class="col-12 col-lg-9 row attribute-images-wrapper">
      <span class="title col-12 p-0">{{attributeGroup.attributeGroupName}}:<small v-show="getSelectedText.length > 0">{{getSelectedText}}</small></span>
      <button
        v-for="attribute in limitedAttributeImages"
        :key="attribute.attributeId"
        :style="btnStyle(attribute.attributeDisplayValue)"
        :class="selected === attribute.attributeId ? 'selected' : ''"
        v-on:click="setSelected(attribute.attributeId)">
      </button>
    </div>
    <div v-if="attributeGroup.attributes.length > 14"
         class="col-12 col-lg-3 attribute-images-see-more-btn"
         @click="openModal()">
      {{ t('attribute.image.selector.see.more.button') }}
    </div>
    <AttributesImagesModal
      v-if="attributeGroup.attributes.length > 14"
      v-show="modalIsOpen"
      :attributeGroup="attributeGroup"
      @attribute-clicked="setSelected"
      @close-modal="closeModalHandler"
    >
    </AttributesImagesModal>
  </div>
</template>

<script>
import AttributesImagesModal from './AttributesImagesModal.vue'
export default {
  name: 'AttributeImageSelector',
  components: {AttributesImagesModal},
  props: ['attributeGroup'],
  data () {
    return {
      version: '0.0.2',
      selected: null,
      modalIsOpen: false
    }
  },
  computed: {
    getSelectedText () {
      if (!this.selected) {
        return ''
      }
      let selected = this.attributeGroup.attributes.find(item => item.attributeId === this.selected)
      if (!selected) {
        return ''
      }
      return selected.attributeName
    },
    limitedAttributeImages () {
      return this.attributeGroup.attributes.slice(0, 14)
    }
  },
  methods: {
    setSelected (attributeId) {
      this.selected = attributeId
      this.$emit('attribute-clicked', attributeId)
    },
    btnStyle (attributeDisplayValue) {
      return 'background-image:url(\'/files/product_attributes/' + attributeDisplayValue + '\')'
    },
    closeModalHandler () {
      this.modalIsOpen = false
    },
    openModal () {
      console.log('openModal')
      this.modalIsOpen = true
    }
  }
}
</script>

<style scoped>
.attribute-images-wrapper {
  display: flex;
  width: 100%;
  flex-flow: wrap;
  gap: 0.5rem;
}

.selected {
  border: 2px solid var(--prime2);
}

.attribute-images-see-more-btn {
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}

.productBgBlock {
  display: flex;
  align-items: flex-end;
  flex-flow: wrap;
}
</style>
